import { ValidationWarning } from './types';

const describeValue = (v: unknown): string => {
  if (v === undefined) return 'undefined';
  if (v === null) return 'null';
  if (typeof v === 'string') return JSON.stringify(v);
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  if (Array.isArray(v)) return `array(length=${v.length})`;
  if (typeof v === 'object') return 'object';
  return typeof v;
};

export const formatWarning = (w: ValidationWarning): string => {
  const base = `at ${w.path || '$'}: expected ${w.expected}, received ${describeValue(w.received)}, used default ${describeValue(w.usedDefault)}`;
  if (w.notes && w.notes.length > 0) {
    return `${base}; ${w.notes.map((n) => `note: ${n}`).join('; ')}`;
  }
  return base;
};

/**
 * The single swappable sink for boundary-validation warnings. Today: log to
 * console. Replace this implementation later (e.g. dispatch into a redux
 * warnings slice) without touching call sites.
 */
export const reportValidationWarnings = (source: string, warnings: Iterable<ValidationWarning>): void => {
  for (const w of warnings) {
    console.warn(`[${source}] ${formatWarning(w)}`);
  }
};
